import { useContext } from 'react'
import { MockAuthContext } from '@/app/providers/mockAuthContext'

export function useMockAuth() {
  const context = useContext(MockAuthContext)

  if (!context) {
    throw new Error('useMockAuth must be used within MockAuthProvider')
  }

  return context
}
